import { render, staticRenderFns } from "./Slidetify.vue?vue&type=template&id=496976be&scoped=true"
import script from "./Slidetify.vue?vue&type=script&lang=ts"
export * from "./Slidetify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496976be",
  null
  
)

export default component.exports